import { render, staticRenderFns } from "./EditActivityForm.vue?vue&type=template&id=b832e54e&"
import script from "./EditActivityForm.vue?vue&type=script&lang=js&"
export * from "./EditActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports